export default __webpack_public_path__ + "static/simplequestions-6f99c05817371da88cbe55d5a453cfe6.png";